export default __webpack_public_path__ + "static/media/layout-3.cbc82458.jpg";